import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";

const PredictionImppChart = ({ chartData, loading = false }) => {
	const [state, setState] = React.useState({
		series: [{
			data: []
		}],
		options: {
			chart: {
				id: 'prediction-impp-datetime',
				type: 'area',
				height: 350,
				zoom: {
					autoScaleYaxis: true
				},
				toolbar: {
					show: true,
					tools: {
						download: true,
						selection: true,
						zoom: true,
						zoomin: true,
						zoomout: true,
						pan: true,
						reset: true,
						customIcons: []
					},
					export: {
						csv: {
							filename: 'prediction-impp-data',
							columnDelimiter: ',',
							headerCategory: 'Date',
							headerValue: 'IMPP (A)',
						},
						png: {
							filename: 'prediction-impp-chart',
						},
						svg: {
							filename: 'prediction-impp-chart',
						},
					}
				}
			},
			colors: ["#8358E8"],
			dataLabels: {
				enabled: false
			},
			markers: {
				size: 0,
				style: 'hollow',
			},
			xaxis: {
				type: 'datetime',
				tickAmount: 6,
			},
			yaxis: {
				labels: {
					formatter: function (value) {
						return value.toFixed(0);
					}
				}
			},
			tooltip: {
				x: {
					format: 'dd MMM yyyy HH:MM'
				},
				y: {
					formatter: function (value) {
						return value.toFixed(1) + ' A';
					}
				},
				style: {
					fontSize: '16px'
				}
			},
			fill: {
				type: 'gradient',
				gradient: {
					shadeIntensity: 1,
					opacityFrom: 0.3,
					opacityTo: 0.6,
					stops: [0, 100]
				}
			},
		}
	});

	useEffect(() => {
		if (chartData && chartData.Impp_mod) {
			console.log("Using prediction Impp_mod data:", chartData.Impp_mod);
			
			const timestamps = chartData.Impp_mod.map(point => point[0]);
			const values = chartData.Impp_mod.map(point => point[1]);
			
			const minTime = Math.min(...timestamps);
			const maxTime = Math.max(...timestamps);
			const minValue = Math.min(...values);
			const maxValue = Math.max(...values);
			
			const timeRange = maxTime - minTime;
			const valueRange = maxValue - minValue;
			const timeBuffer = timeRange * 0.05;
			const valueBuffer = valueRange * 0.05;
			
			setState(prev => ({
				...prev,
				series: [{
					name: 'IMPP (A)',
					data: chartData.Impp_mod
				}],
				options: {
					...prev.options,
					xaxis: {
						...prev.options.xaxis,
						min: minTime - timeBuffer,
						max: maxTime + timeBuffer
					},
					yaxis: {
						...prev.options.yaxis,
						min: minValue - valueBuffer,
						max: maxValue + valueBuffer
					}
				}
			}));
		}
	}, [chartData]);

	if (loading) {
		return (
			<div className="flex justify-center items-center py-20">
				<div className="text-center">
					<div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent mx-auto mb-4"></div>
					<p className="text-lg text-gray-600 font-medium">Loading chart data...</p>
				</div>
			</div>
		);
	}

	if (!chartData || !chartData.Impp_mod || chartData.Impp_mod.length === 0) {
		return (
			<div className="bg-gray-50 p-8 rounded-lg text-center">
				<p className="text-gray-600">No chart data available for this prediction</p>
			</div>
		);
	}

	return (
		<div>
			<div id="chart">
				<div id="chart-timeline">
					<ReactApexChart options={state.options} series={state.series} type="area" height={350} />
				</div>
			</div>
			<div id="html-dist"></div>
		</div>
	);
}

export default PredictionImppChart;